import apiService from '../../apiService'
import Notification from '../../../../../../../resources/js/notification'

export const TYPE_EVERY_MONTH_REPORTS = 'e'
export const TYPE_BOOKKEEPING_DOCUMENTS = 'b'
const DEFAULT_VALUE = []

export default {
  namespaced: true,
  state: {
    everyMonthReports: DEFAULT_VALUE,
    everyMonthReportsLoading: false,
    bookkeepingDocuments: DEFAULT_VALUE,
    bookkeepingDocumentsLoading: false
  },
  mutations: {
    setDocuments (state, { documents, type }) {
      if (type === TYPE_EVERY_MONTH_REPORTS) {
        state.everyMonthReports = documents
      }

      if (type === TYPE_BOOKKEEPING_DOCUMENTS) {
        state.bookkeepingDocuments = documents
      }
    },
    setLoading (state, { loading, type }) {
      if (type === TYPE_EVERY_MONTH_REPORTS) {
        state.everyMonthReportsLoading = loading
      }

      if (type === TYPE_BOOKKEEPING_DOCUMENTS) {
        state.bookkeepingDocumentsLoading = loading
      }
    }
  },
  actions: {
    fetch ({ state, commit }, { domain, type, from, to }) {
      commit('setLoading', { loading: true, type })

      apiService.getDocuments(domain, type, from, to)
        .then(response => {
          commit('setDocuments', {
            documents: response.data.documents,
            type
          })

          commit('setLoading', { loading: false, type })
        })
        .catch(() => {
          commit('setDocuments', {
            documents: DEFAULT_VALUE,
            type
          })
          commit('setLoading', { loading: false, type })

          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить список документов.'
          })
        })
    }
  }
}
